/*
 * @Author: edvardchen
 * @Date:   2016-11-23 22:21:46
 * @Last Modified by:   edvardchen
 * @Last Modified time: 2016-11-23 22:22:33
 */
import shallowEqual from 'fbjs/lib/shallowEqual';

export default function shouldContainerUpdate(nextVariables) {
  return !shallowEqual(this.variables, nextVariables);
}
